export const firebaseConfig = {
  apiKey: "AIzaSyDBhp2Z9I375RmLfpixXy8BLTP5HHWsYHM",
  authDomain: "gitlify.firebaseapp.com",
  projectId: "gitlify",
  storageBucket: "gitlify.appspot.com",
  messagingSenderId: "1088835545488",
  appId: "1:1088835545488:web:7dd0162c6e3de9fcf5eb15",
  measurementId: "G-YZGECW24N1",
};
